module.exports = __webpack_public_path__ + "static/hacker_mind-b9f0632e321716da3225ee7e3e70bd55.svg";